
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  name: 'Select',
  props: {
    modelValue: {
      type: String,
      required: true
    },
    defaultSelectorText: {
      type: String,
      required: true
    },
    options: {
      type: Array as PropType<Array<string>>,
      required: true
    },
    defaultSelectorValue: {
      type: String,
      default: undefined,
      required: false
    }
  },
  methods:{
    handleFirstClick(){
      if(!this.defaultSelectorValue)
        return;
      if(this.modelValue == this.defaultSelectorText){
        this.$emit('update:modelValue', this.defaultSelectorValue);
      }
    }
  }
});
